import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import SpectatorHandler from "@/modules/competitions/services/SpectatorHandler";
import {BeforeMatchEvent} from "@/modules/match/events/BeforeMatchEvent";

@injectable()
export class MatchSpectatorsEventSubscriber implements EventSubscriber {
  constructor(
    @inject(SpectatorHandler) private spectatorHandler: SpectatorHandler,
  ) {}

  priority(): number {
    return 100;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: BeforeMatchEvent, callback: this.onBeforeMatchEvent},
    ];
  }

  async onBeforeMatchEvent(event: BeforeMatchEvent): Promise<void> {
    await this.spectatorHandler.handle(event.match);
  }
}
